import {useCallback, useEffect, useState} from "react";

import type {IUseSearchComboboxModeOptions, IUseSearchComboboxModeResult} from "../types/IUseSearchComboboxModeOptions";
import type {SearchComboboxMode} from "../types/SearchComboboxMode";
import {useLatestRef} from "./use_latest_ref";

const DEFAULT_LAYER_MAX_WIDTH_PX = 1023.98;

const getMediaQueryList = (query: string): MediaQueryList | null =>
    typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query) : null;

const toMode = (isLayer: boolean): SearchComboboxMode => (isLayer ? "layer" : "dropdown");

// Safari < 14 only knows the deprecated `addListener` / `removeListener`.
const subscribe = (mediaQueryList: MediaQueryList, listener: () => void): (() => void) => {
    if (typeof mediaQueryList.addEventListener === "function") {
        mediaQueryList.addEventListener("change", listener);
        return () => mediaQueryList.removeEventListener("change", listener);
    }

    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
};

/**
 * Picks between the anchored dropdown and the full-screen layer without branching the component tree: the mode is
 * read from `matchMedia` at the moment of interaction (`resolveMode()` in the focus/click handler), so SSR markup,
 * hydration and viewport changes never remount the field. `isLayerViewport` is for attributes only (e.g. `readOnly`
 * on the trigger field) and stays false until mounted.
 */
export const useSearchComboboxMode = (options: IUseSearchComboboxModeOptions = {}): IUseSearchComboboxModeResult => {
    const {layerMaxWidthPx = DEFAULT_LAYER_MAX_WIDTH_PX} = options;
    const query = `(max-width: ${layerMaxWidthPx}px)`;
    const [isLayerViewport, setIsLayerViewport] = useState(false);
    const onViewportModeChangeRef = useLatestRef(options.onViewportModeChange);

    useEffect(() => {
        const mediaQueryList = getMediaQueryList(query);

        if (!mediaQueryList) {
            return;
        }

        let isLayer = Boolean(mediaQueryList.matches);
        setIsLayerViewport(isLayer);

        return subscribe(mediaQueryList, () => {
            const nextIsLayer = Boolean(mediaQueryList.matches);

            if (nextIsLayer === isLayer) {
                return;
            }

            isLayer = nextIsLayer;
            setIsLayerViewport(nextIsLayer);
            onViewportModeChangeRef.current?.(toMode(nextIsLayer));
        });
    }, [query]);

    const resolveMode = useCallback(() => toMode(Boolean(getMediaQueryList(query)?.matches)), [query]);

    return {resolveMode, isLayerViewport};
};
import {useCallback, useEffect, useState} from "react";

import type {IUseSearchComboboxModeOptions, IUseSearchComboboxModeResult} from "../types/IUseSearchComboboxModeOptions";
import type {SearchComboboxMode} from "../types/SearchComboboxMode";
import {useLatestRef} from "./use_latest_ref";

const DEFAULT_LAYER_MAX_WIDTH_PX = 1023.98;

const getMediaQueryList = (query: string): MediaQueryList | null =>
    typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query) : null;

const toMode = (isLayer: boolean): SearchComboboxMode => (isLayer ? "layer" : "dropdown");

// Safari < 14 only knows the deprecated `addListener` / `removeListener`.
const subscribe = (mediaQueryList: MediaQueryList, listener: () => void): (() => void) => {
    if (typeof mediaQueryList.addEventListener === "function") {
        mediaQueryList.addEventListener("change", listener);
        return () => mediaQueryList.removeEventListener("change", listener);
    }

    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
};

/**
 * Picks between the anchored dropdown and the full-screen layer without branching the component tree: the mode is
 * read from `matchMedia` at the moment of interaction (`resolveMode()` in the focus/click handler), so SSR markup,
 * hydration and viewport changes never remount the field. `isLayerViewport` is for attributes only (e.g. `readOnly`
 * on the trigger field) and stays false until mounted.
 */
export const useSearchComboboxMode = (options: IUseSearchComboboxModeOptions = {}): IUseSearchComboboxModeResult => {
    const {layerMaxWidthPx = DEFAULT_LAYER_MAX_WIDTH_PX} = options;
    const query = `(max-width: ${layerMaxWidthPx}px)`;
    const [isLayerViewport, setIsLayerViewport] = useState(false);
    const onViewportModeChangeRef = useLatestRef(options.onViewportModeChange);

    useEffect(() => {
        const mediaQueryList = getMediaQueryList(query);

        if (!mediaQueryList) {
            return;
        }

        let isLayer = Boolean(mediaQueryList.matches);
        setIsLayerViewport(isLayer);

        return subscribe(mediaQueryList, () => {
            const nextIsLayer = Boolean(mediaQueryList.matches);

            if (nextIsLayer === isLayer) {
                return;
            }

            isLayer = nextIsLayer;
            setIsLayerViewport(nextIsLayer);
            onViewportModeChangeRef.current?.(toMode(nextIsLayer));
        });
    }, [query]);

    const resolveMode = useCallback(() => toMode(Boolean(getMediaQueryList(query)?.matches)), [query]);

    return {resolveMode, isLayerViewport};
};
